import React, { useEffect, useState } from 'react';
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { getThumbnailUrlFromEmbedLink } from '../../../helper/getThumbnailUrlFromEmbedLink';
import { aedLogoStyle, getDirhamImage, iconContainer, showIconsContainer, termsTitle, whiteCard } from '../../../common/cssclasses';
import { useTranslate } from '../../../components/TranslationText';
import NewActionButton from '../../../components/ActionButtons/NewActionButton';
import { useLocation, useNavigate } from 'react-router';
import { getHorseById } from '../Api/horseMarketApi';

export default function HorseMarketDetailsPage() {
    const { translate } = useTranslate();
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.has("id") ? searchParams.get("id") : null;
    const currentlang = localStorage.getItem('eahsLang') ?? 'en';

    const renderVideo = (item) => {
        return (
            <div className="">
                {item.video === true ? (
                    <iframe
                        width="100%"
                        src={item.embedUrl}
                        frameBorder="0"
                        allowFullScreen={false}
                        style={{ aspectRatio: '16/9' }}
                        title="horse-video"
                    />
                ) : (
                    <React.Fragment></React.Fragment>
                )}
            </div>
        );
    };

    const [horse, setHorse] = useState({});

    const fetchHorse = React.useCallback(() => {
        if (id) {
            getHorseById(id).then(res => setHorse(res || {}));
        }
    }, [id]);

    const gallery = horse?.stallionImage?.map((item) => (
        item.fileType === 'Image'
            ? { original: item.fileUrl, thumbnail: item.fileUrl }
            : { embedUrl: item.fileUrl, thumbnail: getThumbnailUrlFromEmbedLink(item.fileUrl), video: true, renderItem: renderVideo }
    )) || [];

    useEffect(() => {
        fetchHorse();
    }, [fetchHorse]);

    return (
        <div className='row'>
            <h2 className={termsTitle + " d-flex align-items-center flex-wrap mb-main"}>
                {!!horse?.regNr && horse.regNr + " - "} {horse?.horseName}
            </h2>
            <div className={showIconsContainer}>
                {detailsRow('fa fa-user', 'web.owner', horse?.owner, 'w-unset')}

                <div className={iconContainer}>
                    <img src={getDirhamImage(currentlang)} alt='AED' style={aedLogoStyle} />
                    <span className='fw-bold'>
                        {`${translate("web.price", "Price") + ": "}`} {horse?.price?.toLocaleString("en-US")} {translate('web.aed', 'AED')}
                    </span>
                </div>
            </div>
            <div className='col-md-8 col-12'>
                <style>
                    {`
                    .image-gallery { border-radius:15px; overflow:hidden; }
                    .image-gallery-slide img {
                        height: 450px;
                        object-fit: contain;
                        background-color: #f8f9fa;
                    }
                    .image-gallery-thumbnail-inner img {
                        height: 80px;
                        object-fit: cover;
                    }
                    `}
                </style>
                <div className={whiteCard}>
                    {gallery.length > 0 && (
                        <ImageGallery
                            items={gallery}
                            showPlayButton={false}
                            showIndex={true}
                            showFullscreenButton={true}
                        />
                    )}
                </div>
            </div>
            <div className='col-md-4 col-12'>
                <div className={whiteCard}>
                    {horse?.description && (
                        <div className="mb-4">
                            <h5 className="fw-bold C89C66 mb-2">{translate('web.horseDescription', 'Description')}</h5>
                            <p className="mb-0" style={{ whiteSpace: 'pre-line', lineHeight: '1.6' }}>{horse.description}</p>
                        </div>
                    )}
                    {rightDetails('fa fa-calendar', 'web.birthDate', horse?.birthDate)}
                    {rightDetails('fa fa-palette', 'web.color', horse?.color)}
                    {rightDetails('fa fa-earth-americas', 'web.origin', horse?.origin)}
                    {rightDetails('fa fa-tags', 'web.sire', horse?.sireName)}
                    {rightDetails('fa fa-tags', 'web.dam', horse?.damName)}
                    {rightDetails('fa fa-envelope', 'web.email', horse?.ownerMail)}
                    {rightDetails('fa fa-phone', 'web.phone', horse?.ownerPhone)}
                    {rightDetails('fa fa-location-dot', 'web.address', horse?.address)}
                    <div className='row'>
                        <div className='ms-auto w-unset d-flex align-items-center flex-wrap'>
                            <NewActionButton
                                classNames='btn-outline-danger w-unset'
                                text={translate('web.StudBookDetails', 'StudBook Details')}
                                onClick={() => {
                                    navigate(`/horsedetails?horseId=${horse?.stallionId}&title=${encodeURIComponent(horse?.horseName || horse?.name || '')}`);
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    function detailsRow(icon = '', key = "", value = "", classNames = "") {
        return (
            <div className={iconContainer + ' ' + classNames}>
                <i className={`${icon} C89C66`} />
                <span className='fw-bold'>
                    {translate(key, key) + ": "} {!!value ? value : translate("web.unknown", "unknown")}
                </span>
            </div>
        );
    }

    function rightDetails(icon = '', key = "", value = "") {
        if (!value) return <></>;
        return (
            <div className='col-sm-12 col-12 mb-2'>
                <span className="fw-bold">
                    <i className={`${icon} C89C66 me-2`} />
                    {translate(key, key) + ":"}
                </span>
                <span className="fw-bold ms-2">
                    {!!value ? value : '-'}
                </span>
            </div>
        );
    }
}
